export const trackersGoogleAnalytics = {
  loaded: false,
  enabled: false,

  // Load Google Analytics and begin tracking.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!
  load: function(gaId, linkedDomains) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Google Analytics");

      // See https://developers.google.com/analytics/devguides/collection/analyticsjs
      (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

      (function () {
        if (linkedDomains && linkedDomains.length > 0) {
          // Setup linked domains, see https://support.google.com/tagmanager/answer/7549390
          ga('create', gaId, 'auto', { 'allowLinker': true });
          ga('require', 'linker');
          ga('linker:autoLink', linkedDomains);
        } else {
          ga('create', gaId, 'auto');
        }
        ga('send', 'pageview');
      }());

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Google Analytics scripts already loaded - re-enabling");
      // Ensure ga is not disabled, see https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
      window[`ga-disable-${gaId}`] = false;
      this.enabled = true;
    }
  },

  // Revoke consent for this user to be tracked by Google Analytics
  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
  revokeConsent: function(gaId) {
    console.log("Disabling Google Analytics");
    window[`ga-disable-${gaId}`] = true;
    this.enabled = false;
  }
};
